import { Outlet } from "@remix-run/react";

export default function CompaniesPage() {
  return <Outlet />;
}
